import SwitchDetailCard from './SwitchDetailCard'

export default SwitchDetailCard
